import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  protected url: string = environment.workflowApi.url;
  headers: Headers;
  http: HttpClient;

  constructor(private httpservice: HttpClient) {
    this.http = httpservice;
    this.headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
  }

  initiateCarrierWorkflow(carrier_id: number){
    return this.http.get(`${this.url}Activity/carrier/${carrier_id}`);
  }

  initiatePermitWorkflow(application_id: number){
    return this.http.get(`${this.url}Activity/permit/${application_id}`);
  }

  initiateComplianceWorkflow(application_id: number){
    return this.http.get(`${this.url}Activity/compliance/${application_id}`);
  }

  getActivity(activity_id: number){
    return this.http.get(`${this.url}Activity/${activity_id}`);
  }

  getApplicationActivity(application_id: number){
    return this.http.get(`${this.url}Activity/byapp/${application_id}`);
  }

  getAllActivity(pageSize, pageNum){
    return this.http.get(`${this.url}Activity/all/${pageSize}/${pageNum}`);
  }

  getUserActivity(role_id: number, username: string, pageSize, pageNum){
    return this.http.get(`${this.url}Activity/${role_id}/${username}/${pageSize}/${pageNum}`);
  }

  getGroupActivity(rolename: string, pageSize, pageNum){
    return this.http.get(`${this.url}Activity/group/${rolename}/${pageSize}/${pageNum}`);
  }

  assignActivityToUser(username: string, application_id: number){
    return this.http.get(`${this.url}Activity/assign/${username}/${application_id}`);
  }

  getWorkflowTimeline(application_id: number){
    return this.http.get(`${this.url}Activity/timeline/${application_id}`);
  }

  getRoleUsers(role_id: number){
    return this.http.get(`${this.url}Activity/roleusers/${role_id}`);
  }

  getActionsByRole(role_id: number, activity_id: number){
    return this.http.get(`${this.url}Actions/byroleid/${role_id}/${activity_id}`);
  }

  processActivity(activitydto: any, app_type){
    return this.http.post(`${this.url}Activity/${app_type}/process`, activitydto);
  }

  reassignActivity(activity_id: number, username: string) {
    var body: any;
    return this.http.post(`${this.url}Activity/reassign/${activity_id}/${username}`, body);
  }

  getUserData(userassigned:string, activity_id:number){
    return this.http.get(`${this.url}Activity/user/data/${userassigned}/${activity_id}`);
  }

  getDashboardData(){
    return this.http.get(`${this.url}Activity/dashboard/data`);
  }

  getWorkflowUsers(){
    return this.http.get(`${this.url}Activity/wfroleusers`);
  }

  protected getRequest(url: string) {
    return this.http.get(url);
  }

  add(body: any) {
    return this.http.post(this.url, body);
  }

  delete(id: number) {
    return this.http.delete(this.url + '/' + id);
  }

  update(body: any = []) {
    return this.http.put(this.url, body);
  }

  getUserActivityFiltered(filters:any, role_id: number, username: string, pageSize, pageNum){
    return this.http.post(`${this.url}Activity/filtered/${role_id}/${username}/${pageSize}/${pageNum}`,filters);
  }

  getAllActivityFiltered(filters:any, pageSize, pageNum){
    console.log(filters)
    return this.http.post(`${this.url}Activity/all/filtered/${pageSize}/${pageNum}`,filters);
  }

  //#region Status
  getWorkflowStatus(){
    return this.http.get(`${this.url}Status/listall`);
  }

  addWorkflowStatus(body: any) {
    return this.http.post(`${this.url}Status`, body);
  }

  updateWorkflowStatus(id: any, body: any) {
    return this.http.put(`${this.url}Status/${id}`, body);
  }

  deleteWorkflowStatus(id: any) {
    return this.http.delete(`${this.url}Status/${id}`);
  }  
  //#endregion

  //#region Actions
  getWorkflowAction(){
    return this.http.get(`${this.url}Actions/listall`);
  }

  addWorkflowAction(body: any) {
    return this.http.post(`${this.url}Actions`, body);
  }

  updateWorkflowAction(id: any, body: any) {
    return this.http.put(`${this.url}Actions/${id}`, body);
  }

  deleteWorkflowAction(id: any) {
    return this.http.delete(`${this.url}Actions/${id}`);
  }  
  //#endregion

  //#region Route Types
  getWorkflowRouteType(){
    return this.http.get(`${this.url}RouteTypes/listall`);
  }

  addWorkflowRouteType(body: any) {
    return this.http.post(`${this.url}RouteTypes`, body);
  }

  updateWorkflowRouteType(id: any, body: any) {
    return this.http.put(`${this.url}RouteTypes/${id}`, body);
  }

  deleteWorkflowRouteType(id: any) {
    return this.http.delete(`${this.url}RouteTypes/${id}`);
  }  
  //#endregion

  //#region Routes
    getWorkflowRoutes(){
    return this.http.get(`${this.url}Routes/listall`);
    }

    getWorkflowRoutesPaging(pageIndex:any, pageSize:any){
      return this.http.get(`${this.url}Routes/listall/${pageIndex}/${pageSize}`);
    }

    getWorkflowRouteByRouteID(routesid:any){
      return this.http.get(`${this.url}Routes/byroutesid/${routesid}`);
    }

    getWorkflowRouteByTypeID(routetypeid:any){
      return this.http.get(`${this.url}Routes/byroutetypeid/${routetypeid}`);
    }
  
    addWorkflowRoute(body: any) {
      return this.http.post(`${this.url}Routes`, body);
    }
  
    updateWorkflowRoute(id: any, body: any) {
      return this.http.put(`${this.url}Routes/${id}`, body);
    }
  
    deleteWorkflowRoute(id: any) {
      return this.http.delete(`${this.url}Routes/${id}`);
    }  
  //#endregion

  //#region Delegation


    getDelegations(){
    return this.http.get(`${this.url}UnavailableUser/listall`);
    }

    getDelegationsPaging(pageIndex:any, pageSize:any){
      return this.http.get(`${this.url}UnavailableUser/listall/${pageIndex}/${pageSize}`);
    }

    getDelegationsByDelegationsID(unavailableuserid:any){
      return this.http.get(`${this.url}UnavailableUser/byunavailableuserid/${unavailableuserid}`);
    }

    getDelegationsByAwayUser(awayuser:any){
      return this.http.get(`${this.url}UnavailableUser/byawayuser/${awayuser}`);
    }
  
    addDelegations(body: any) {
      return this.http.post(`${this.url}UnavailableUser`, body);
    }
  
    updateDelegations(id: any, body: any) {
      return this.http.put(`${this.url}UnavailableUser/${id}`, body);
    }
  
    deleteDelegations(id: any) {
      return this.http.delete(`${this.url}UnavailableUser/${id}`);
    }  
  //#endregion

}
